import * as React from 'react';
import {NavTabs, NavTabPanel} from '../../nav-tabs';
import {ISessionChallenge} from '../../../redux/modules/session/reducer';
import './styles.sass';

export interface ISessionTabsProps extends ISessionChallenge {}

export const SessionTabs: React.StatelessComponent<ISessionTabsProps> = ({challenge}: ISessionTabsProps) => (
  <NavTabs className={'session-tabs'} key={`session-tabs-${challenge.length}`}>
    {
      challenge.map((tab, key) => (
        <NavTabPanel
          markdown={tab.type === 'md'}
          title={tab.title}
          key={key}
        >
          {tab.content}
        </NavTabPanel>
      ))
    }
  </NavTabs>
);
